/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  FormField,
  TextInput,
  GDSStyleObject,
  Select,
  InputStatusMessage,
} from '@leagueplatform/genesis-core';
import {
  stateOption,
  formatPhoneNumber,
  formatConfirmationCode,
  formatAddressField,
  formatCityField,
} from '../../utils/helper';
import { PopOver } from './popOver';
import * as CONSTANTS from '../../utils/constant';
import { FormFields } from '../../types/contactInfo-library.types';

export function CustomInput(props: FormFields) {
  const { type, label, id, onChange, val, disable, err, onBlur, onKeyPress } =
    props;
  return (
    <div style={{ padding: '10px 0' }}>
      <FormField
        id={id}
        label={
          <span>
            {label}
            {id === 'secondaryemail' && <PopOver />}
          </span>
        }
        inputStatus={err ? 'error' : undefined}
        statusMessage={<InputStatusMessage hideIcon>{err}</InputStatusMessage>}
        css={
          {
            '.GDS-input-wrapper': {
              padding: '$half $none',
              backgroundColor: '$highlightBackgroundSecondary',
            },
          } as GDSStyleObject
        }
        hideLabel={{
          '@initial': false,
          '@tablet': false,
          '@laptop': false,
          '@mobile': false,
          '@mobileLandscape': false,
        }}
      >
        {type === 'input' ? (
          <TextInput
            type="text"
            data-testid="custom-input"
            onChange={(e) => onChange(e)}
            readOnly={disable}
            onBlur={onBlur}
            onKeyUp={onKeyPress}
            maxLength={CONSTANTS.ADDRESS_MAX_LENGTH}
            value={
              id === 'address1' || id === 'address2'
                ? formatAddressField(val)
                : id === 'city'
                ? formatCityField(val)
                : val
            }
          />
        ) : type === 'number' ? (
          <TextInput
            type="text"
            data-testid="custom-number"
            onChange={(e) => onChange(e)}
            readOnly={disable}
            onBlur={onBlur}
            onKeyUp={onKeyPress}
            value={
              id === 'zip'
                ? formatConfirmationCode(val)
                : formatPhoneNumber(val)
            }
            maxLength={
              id === 'zip'
                ? CONSTANTS.ZIP_MAX_LENGTH
                : CONSTANTS.PHONE_MAX_LENGTH
            }
          />
        ) : type === 'select' ? (
          <Select
            id={id}
            data-testid="custom-select"
            options={stateOption()}
            disabled={disable}
            onBlur={onBlur}
            placeholder="Please Select"
            value={val}
            onChange={(e) => onChange(e)}
          />
        ) : null}
      </FormField>
    </div>
  );
}
